// src/services/userService.ts
import { api } from './api';
import { Role } from '../services/authService';

// Define Department interface since it's used in User
export interface Department {
  _id: string;
  name: string;
}

export interface User {
  _id: string;
  name: string;
  email: string;
  phone?: string;
  role: Role | string;
  status?: string;
  department: Department | string;
  isClient?: boolean;
  createdAt?: string;
  updatedAt?: string;
  __v?: number;
}

// Define the API response format based on actual data

interface UsersData {
  result: User[];
  totalCount: number;
  currentPage: number;
  totalPages: number;
  previousPage: number | null;
  nextPage: number | null;
}

interface UserResponse {
  message: string;
  data: User;
  error: boolean;
}

interface UsersResponse {
  message: string;
  data: UsersData | User[];
  error: boolean;
}

export interface UserFormData {
  name: string;
  email: string;
  password: string;
  role: string;
  department: string;
}

export interface UserUpdateData {
  name?: string;
  email?: string;
  password?: string;
  role?: string;
  department?: string;
}

export const userService = {
  async getAllUsers(page?: number): Promise<UsersData | User[]> {
    const params = page !== undefined ? { page } : {};
    const response = await api.get<UsersResponse>('/user', { params });
    return response.data.data;
  },
  
  async getUser(id: string): Promise<User> {
    const response = await api.get<UserResponse>(`/user/${id}`);
    return response.data.data;
  },
  
  async createUser(userData: UserFormData): Promise<User> {
    const response = await api.post<UserResponse>('/user', userData);
    return response.data.data;
  },
  
  async updateUser(id: string, userData: UserUpdateData): Promise<User> {
    const response = await api.put<UserResponse>(`/user/${id}`, userData);
    return response.data.data;
  },
  
  async deleteUser(id: string): Promise<void> {
    await api.delete(`/user/${id}`);
  }
};